/**
 * Module version of _mailcheck.tt
 * Lazy loads mailcheck assets. Used for email validation and typo correction.
 *
 * @param {string} options.emailSuggestionTemplate suggestion template
 * @param {string} options.emailSuggestionYes Yes button text
 * @param {string} options.emailSuggestionNo No button text
 * @param {string} options.emailSuggestionTemplateVariable the variable in emailSuggestionTemplate that we will replace with the user's email.
 */
async function loadMailcheck({
  emailSuggestionTemplateVariable = '{{address}}',
  emailSuggestionTemplate = 'Did you mean <strong>{{address}}</strong>?',
  emailSuggestionYes = 'Yes',
  emailSuggestionNo = 'No',
}) {
  // zr.mailcheck reads from this
  window.zr.page.model.email_suggestion_template_variable = emailSuggestionTemplateVariable;
  window.zr.page.model.email_suggestion_template = emailSuggestionTemplate;
  window.zr.page.model.email_suggestion_yes = emailSuggestionYes;
  window.zr.page.model.email_suggestion_no = emailSuggestionNo;

  // we can download these 'setup' assets in parallel
  await Promise.all([
    import(/* webpackChunkName: "_mailcheck.less" */ '../css/_mailcheck.less'),
    import(/* webpackChunkName: "damerauLevenshtein" */ '@static/js/zr/util/damerauLevenshtein'),
    import(/* webpackChunkName: "mailcheck" */ '@static/js/vendor/mailcheck/1.1.2/mailcheck'),
  ]);
  // zr.mailcheck reads globally set functions by the setup javascript, so only import when the setup is done
  await import(/* webpackChunkName: "zr.mailcheck" */ '@static/js/zr/zr.mailcheck');
}

export default loadMailcheck;
